import { Injectable } from '@angular/core';
import {Observable, of} from "rxjs";
import {API_URLS} from "../../app-config/api.url.config";
import {HttpClient} from "@angular/common/http";
import {TrackrespModel} from "../models/trackresp.model";
import {TrackreqModel} from "../models/trackreq.model";
import {PassportData} from "../models/PassportData.model";

@Injectable({
  providedIn: 'root'
})
export class TrackService {

  constructor(private httpClient: HttpClient) { }

  track(userData: TrackreqModel): Observable<TrackrespModel<PassportData>> {
    return this.httpClient.post<TrackrespModel<PassportData>>(API_URLS.API_URLS_TRACK_PASSPORT, userData);
  }
}
